module.exports = __webpack_public_path__ + "static/water_weird-83371120db899a939a2102318b4d69d2.jpeg";